import PropTypes from 'prop-types';
import { URANUS_LAYER } from 'HubStyleTokens/sizes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const DomainNotConnectedErrorTooltip = ({
  children
}) => /*#__PURE__*/_jsx(UITooltip, {
  placement: "bottom left",
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "knowledgeContentUI.shared.domainNotConnectedError"
  })
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  ,
  zIndex: parseInt(URANUS_LAYER, 10),
  children: children
});
DomainNotConnectedErrorTooltip.propTypes = {
  children: PropTypes.element.isRequired
};
export default DomainNotConnectedErrorTooltip;